import React, { useState } from "react";

const useForm = (initialState, validate, setPasswordCriteria, setIsPassword, setProfileImage, setPreviewUrl) => {
    const [formData, setFormData] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    // Handle input change
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'newPassword') {
            setPasswordCriteria({
                length: value.length >= 8,
                uppercase: /[A-Z]/.test(value),
                number: /[0-9]/.test(value),
                noSpaces: !/\s/.test(value),
            });
            if (value.length > 0) {
                setIsPassword(true)
            } else {
                setIsPassword(false)
            }
        } else if (name === "profileImage") {
            setProfileImage(null);
            setFormData((prevData) => ({
                ...prevData,
                [name]: files[0],
            }));
            if (files[0]) {
                setPreviewUrl(URL.createObjectURL(files[0]));
            }
        }

        // Validate the field on change
        if (validate && isSubmitted) {
            const newErrors = validate({ ...formData, [name]: files ? files[0] : value });
            setErrors(newErrors);
        }
    };

    // Handle form submission
    const handleSubmit = (e, callback) => {
        e.preventDefault();

        setIsSubmitted(true)

        if (validate) {
            const newErrors = validate(formData);
            setErrors(newErrors);

            if (Object.keys(newErrors).length === 0 && callback) {
                callback();
            }
        }
    };

    return {
        formData,
        errors,
        handleChange,
        handleSubmit,
        setFormData,
        setErrors,
        setIsSubmitted
    };
};

export default useForm;
